import { Component, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { AuthenticationService } from './../../services/authentication.service'
import { User } from './../../models/User'
import { NotificationService } from './../../services/notification.service'
import { ViewValidation }  from '../../_helpers/ViewValidation'

@Component({
	selector: 'app-reset-password',
	templateUrl: './reset-password.component.html'
})

export class ResetPasswordComponent implements OnInit {

	public user: User
	public token: string
	public passwordData: string
	public repasswordData: string
	public loading: boolean = false
	public ViewValidation: ViewValidation = new ViewValidation()

	constructor(
		private authenticationService: AuthenticationService,
		private notificationService: NotificationService,
		private router: Router,
		private activatedRoute: ActivatedRoute) { }

	public ngOnInit() {
		this.notificationService.starterLoading.subscribe(() => this.loading = true)
		this.notificationService.stopperLoading.subscribe(() => this.loading = false)
		this.token = this.activatedRoute.snapshot.queryParams.q
		if (this.token) {
			this.authenticationService.getUserByToken(this.token)
				.subscribe(
					success => {
						if (success) {
							this.user = success
						}
					}, error => {
						this.notificationService.notify('O Token expirado ou não encontrado. Solicite novamente a redefinição de senha', 420)
						this.router.navigate(['/login'])
					})
		} else {
			this.router.navigate(['/login'])
		}
	}

	public changePassword() {
		if (this.user && this.passwordData && this.repasswordData && this.passwordData == this.repasswordData) {
			this.authenticationService.changePassword(this.token, this.passwordData)
				.subscribe(
					success => {
						if (success) {
							this.notificationService.notify('Redefinição de senha realizada com sucesso', 200)
							this.router.navigate(['/login'])
						}
					}, error => {
					})
		} else {
			this.notificationService.notify('Senha e confirmação de senha não conferem', 420)
		}
	}

}
